import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'css-invoice-header',
  templateUrl: './css.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./css.css']
})
export class CssInvoiceHeaderComponent {}
